import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../../services/GetTemplate';
// import "../faqs/faqList.scss";
import { TabMenu } from 'primereact/tabmenu';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { TabPanel, TabView } from 'primereact/tabview';
import "../tutorials/tutorials.css"
function Tutorials() {
    const [tutorialList, setTutorialList] = useState([]);
    const dispatch = useDispatch();

    const getTutorialList = async () => {
        const response = await dispatch(handleGetRequest("api/web/tutorial", true, true));
        setTutorialList(response?.data || []);
        console.log(response?.data,"data")
        
    };

    useEffect(() => {
        getTutorialList();
    }, []);

    console.log(tutorialList.map((category) => {
        return category?.videoLink
    }), "res")
    const getEmbedLink = (url) => {
        // Check if the video link is in the shortened YouTube format
        const videoId = url.split('youtu.be/')[1];
        return `https://www.youtube.com/embed/${videoId}`;
    };
    const embeded = getEmbedLink("https://youtu.be/2nlge-PjvtU");

    console.log(embeded,"emnhj")
    return (
        <>
            <TabView className="p-2 border-200 border-3 border-round">
                {tutorialList.map((category) => (
                    <TabPanel key={category?.category?._id} header={category?.category?.name}>
                        <Accordion activeIndex={0} style={{margin:"0.1rem!important"}}>
                           
                                <AccordionTab key={category?._id} header={category?.title}>
                                    <div className='flex justify-content-center video-wrapper'>
                                        <iframe
                                            width="560"
                                            height="315"
                                            src={getEmbedLink(category?.videoLink)}
                                            // src={category?.videoLink}
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </AccordionTab>
                            
                        </Accordion>
                    </TabPanel>
                ))}
            </TabView>
            {/* <TabView className='p-3 border-200 border-3 border-round'>
                <TabPanel header="Passenger">
                    <Accordion activeIndex={0}>
                        <AccordionTab header="Info" >
                            <div className='flex justify-content-center'>
                                <iframe
                                    width="560"
                                    height="315"
                                    src="https://youtu.be/ULHKx04rJ7s?si=q9aJRy4Fg0V90sax"
                                    title="YouTube video player"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </AccordionTab>
                    </Accordion>
                </TabPanel>
            </TabView> */}
        </>
    );
}

export default Tutorials;
